import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import MyDatePicker from "../widgets/DatePicker";
import SelectInput from "../widgets/SelectInput";
import Checkbox from "../widgets/CheckBox";
import moment from "moment";
import _ from 'lodash/cloneDeep';
import addFattura from "../services/addFattura";
import addUscita from "../services/addUscita";
import Loading from "../components/Loading";
import getImpostazioni from "../services/getImpostazioni";
import addSpesa from "../services/addSpesa";
import getFatturaRif from "../services/getFatturaRif";
import { Stack } from "@mui/system";
import { Typography, makeStyles } from "@material-ui/core";
import deleteFatturaProvvisoria from "../services/deleteFatturaProvvisoria";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class AddFattura extends React.Component {
    constructor(props) {
        super(props)

        this.fatturaDateRef = React.createRef();
        this.customDispRef = React.createRef();

        this.disposizioni = [
            { value: 0, label: 'Immediato' },
            { value: 30, label: '30 GG.DF.FM.' },
            { value: 60, label: '60 GG.DF.FM.' },
            { value: 90, label: '90 GG.DF.FM.' },
            { value: 120, label: '120 GG.DF.FM.' },
            { value: 150, label: '150 GG.DF.FM.' },
            { value: 180, label: '180 GG.DF.FM.' },
            { value: 1000, label: 'Personalizza' },
        ];

        this.tipiDocumenti = [
            { value: 0, label: 'Non definito' },
            { value: 1, label: 'Fattura' },
            { value: 2, label: 'Fattura differita di cui l’art. 21, comma 4, lett. a' },
            { value: 3, label: 'Nota di Credito' },
            { value: 4, label: 'Acconto/Anticipo su Fattura' }
        ];

        this.types = [
            { value: 0, label: 'Fattura' },
            { value: 1, label: 'Spesa non fatturata' }
        ];

        this.state = {
            isLoading: true,
            ragioneSociale: '',
            numeroFattura: '',
            dataFattura: new Date(),
            ritenuta: 0,
            importo: '',
            sdi: '',
            tag: { value: 100, label: '' },
            elettronica: 1,
            tipoDocumento: this.tipiDocumenti[0],
            disposizioni: [this.disposizioni[0]],
            type: this.types[0],
            descrizione: '',
            customDisposizione: false,
        };

    }

    async componentDidMount() {

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });

        let impostazioni = await getImpostazioni(username, token);

        this.tags = impostazioni.find(i => i.tipo === 'anagrafiche');
        this.tags = JSON.parse(this.tags.payload);
        this.tags.forEach((t, i) => {
            this.tags[i] = { value: parseInt(t.scarico), label: t.label }
        });

        this.tags = [{ value: 100, label: "" }, ...this.tags];

        this.metodiPagamento = impostazioni.find(i => i.tipo === 'pagamenti');
        this.metodiPagamento = JSON.parse(this.metodiPagamento.payload);
        this.metodiPagamento.forEach((t, i) => {
            this.metodiPagamento[i] = { value: t.label, label: t.label }
        });

        this.metodiPagamento = [{ value: "", label: "" }, ...this.metodiPagamento];
        this.setState({ isLoading: false });
    }

    componentDidUpdate() {
        if (this.state.disposizioni) {
            var found = false;
            this.state.disposizioni.forEach(d => {
                if (d.value === 1000 && !this.state.customDisposizione) {
                    this.setState({ customDisposizione: true });
                    found = true;
                    return;
                } else if (d.value === 1000) {
                    found = true;
                    return;
                }
            });

            if (!found && this.state.customDisposizione) this.setState({ customDisposizione: false });
        }
    }

    render() {

        if (this.state.isLoading) return <Loading />;

        return (
            <>
                <PageTitle title={'Nuova fattura'} />

                <div style={{ marginTop: -20, marginBottom: 30 }}>
                    <SelectInput
                        key={Math.random()}
                        value={this.state.type}
                        name={""}
                        options={this.types}
                        onChange={(option) => {
                            this.setState({ type: option });
                        }}
                    />
                </div>

                {this.state.type.value === 0 ? (
                    <>
                        <SelectInput
                            key={Math.random()}
                            value={this.state.tag}
                            name={"Tag"}
                            options={this.tags}
                            onChange={(option) => {
                                this.setState({ tag: option });
                            }}
                        />

                        {this.state.tag.label === 'Fornitore' &&
                            <TextInput
                                name={'Rif ordine'}
                                value={this.state.rifOrdine}
                                onChange={(text) => { this.setState({ rifOrdine: text }) }}
                                onBlur={async (text) => {
                                    let res = await getFatturaRif(username, token, text);
                                    if (res.result === 'ok') {
                                        this.setState({ fattura_provvisoria: res.fattura.id });
                                    } else {
                                        this.setState({ fattura_provvisoria: '' });
                                    }
                                }} />
                        }

                        {
                            (this.state.fattura_provvisoria && this.state.fattura_provvisoria !== '') && (
                                <Stack>
                                    <Typography variant="subtitle2">
                                        Trovata una fattura provvisoria con riferimento {this.state.rifOrdine}.
                                    </Typography>
                                    <Typography color="error" variant="subtitle2">
                                        La fattura provvisoria verrà cancellata.
                                    </Typography>
                                </Stack>
                            )
                        }

                        <SelectInput
                            key={Math.random()}
                            value={this.state.tipoDocumento}
                            name={"Tipo documento"}
                            options={this.tipiDocumenti}
                            onChange={(option) => {
                                this.setState({ tipoDocumento: option });
                            }}
                        />

                        <TextInput name={'Ragione sociale mittente'} value={this.state.ragioneSociale}
                            onChange={(text) => { this.setState({ ragioneSociale: text }) }
                            } />

                        <TextInput name={'Numero fattura'} value={this.state.numeroFattura} onChange={(text) => { this.setState({ numeroFattura: text }) }} />

                        <MyDatePicker ref={this.fatturaDateRef} name={'Data fattura'} value={this.state.dataFattura} />

                        <div style={{ height: 30 }}></div>

                        <TextInput noState={true} name={'Importo fattura'} value={this.state.importo}
                            onChange={(text) => {
                                var t = text.replace(/\./g, '');
                                if (/[^0-9,]+/.test(t)) {
                                    t = t.replace(/[^0-9]+/g, '');
                                }
                                var chunks = t.split(',');
                                chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                t = chunks.join(',');
                                this.setState({ importo: t.trim() });
                            }}
                        />

                        <TextInput name={'Identificativo SDI'} value={this.state.sdi}
                            onChange={(text) => { this.setState({ sdi: text }) }
                            } />

                        <SelectInput
                            key={Math.random()}
                            value={this.state.disposizioni}
                            isMulti={true}
                            name={"Disposizioni di pagamento"}
                            options={this.disposizioni}
                            onChange={(option) => {
                                this.setState({ disposizioni: option });
                            }}
                        />

                        {this.state.customDisposizione && (
                            <MyDatePicker ref={this.customDispRef} name={'Data disposizione'} value={this.state.dataCustomDisposizione} />
                        )}

                        <SelectInput
                            key={Math.random()}
                            value={this.state.metodoPagamento}
                            name={"Metodo di pagamento"}
                            options={this.metodiPagamento}
                            onChange={(option) => {
                                this.setState({ metodoPagamento: option });
                            }}
                        />

                        <div style={{ marginLeft: 8, marginTop: 10, display: 'flex', alignItems: 'center' }}>
                            <p>Ritenuta d'acconto</p>
                            <Checkbox
                                checked={this.state.ritenuta === 1 ? true : false}
                                name={'ritenuta'}
                                style={{ marginTop: 5, marginLeft: 15 }}
                                onElementCheck={(val) => this.setState({ ritenuta: val === true ? 1 : 0 })}
                            />
                        </div>

                        <div style={{ marginLeft: 8, marginTop: -10, display: 'flex', alignItems: 'center' }}>
                            <p>Fattura non elettronica</p>
                            <Checkbox
                                checked={this.state.elettronica === 0 ? true : false}
                                name={'n_elettronica'}
                                style={{ marginTop: 5, marginLeft: 15 }}
                                onElementCheck={(val) => this.setState({ elettronica: val === true ? 0 : 1 })}
                            />
                        </div><br />
                    </>
                ) : (
                    <>
                        <SelectInput
                            key={Math.random()}
                            value={this.state.tag}
                            name={"Tag"}
                            options={this.tags}
                            onChange={(option) => {
                                this.setState({ tag: option });
                            }}
                        />

                        <TextInput name={'Descrizione'} value={this.state.descrizione}
                            onChange={(text) => { this.setState({ descrizione: text }) }
                            } />

                        <MyDatePicker ref={this.fatturaDateRef} name={'Data pagamento'} value={this.state.dataFattura} />
                        <div style={{ height: 30 }}></div>

                        <TextInput noState={true} name={'Importo fattura'} value={this.state.importo}
                            onChange={(text) => {
                                var t = text.replace(/\./g, '');
                                if (/[^0-9,]+/.test(t)) {
                                    t = t.replace(/[^0-9]+/g, '');
                                }
                                var chunks = t.split(',');
                                chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                t = chunks.join(',');
                                this.setState({ importo: t.trim() });
                            }}
                        />

                        <SelectInput
                            key={Math.random()}
                            value={this.state.metodoPagamento}
                            name={"Metodo di pagamento"}
                            options={this.metodiPagamento}
                            onChange={(option) => {
                                this.setState({ metodoPagamento: option });
                            }}
                        />
                    </>
                )}

                <div style={{ height: 30 }}></div>
                <FixButton title={'Salva'} callback={() => this.save()} />
            </>
        );
    }

    async save() {

        this.setState({ isLoading: true });
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        if (this.state.type.value === 0) {

            if (this.state.fattura_provvisoria && this.state.fattura_provvisoria !== '') {
                if (!window.confirm('La fattura provvisoria verra cancellata. Continuare?')) {
                    return;
                }
            }

            // Fattura
            if (this.state.tipoDocumento.value === 0) {
                alert('Inserire una tipologia di documento valida');
                return;
            }

            if (!this.state.ragioneSociale) {
                alert('Inserire una ragione sociale valida');
                return;
            }

            if (!this.state.importo) {
                alert('Inserire un importo per la fattura');
                return;
            }

            if (this.state.disposizioni.length === 0) {
                alert('Inserire almeno una disposizione di pagamento');
                return;
            }

            var data = this.fatturaDateRef.current.getDate();
            data = moment(data).format('DD/MM/yyyy');

            var custom = [];
            let singolaRata = parseFloat(this.state.importo.replace(/\./g, '').replace(/,/g, '.')) / this.state.disposizioni.length;
            var dataFattura = moment(this.fatturaDateRef.current.getDate());
            dataFattura = _(dataFattura);
            let error = false;
            this.state.disposizioni.forEach(d => {
                var data = '';
                if (d.value === 0) {
                    // Immediato
                    data = dataFattura.add(d.value, 'd').format('DD/MM/yyyy');
                } else {
                    var startDate = dataFattura.format('DD/MM/yyyy');
                    var chunks = startDate.split('/');
                    chunks[0] = '01';
                    startDate = chunks.join('/');
                    let oneMonthDate = moment(startDate, 'DD/MM/yyyy').add(1, 'month');
                    data = oneMonthDate.endOf('month').format('DD/MM/yyyy');
                }
                custom.push({ data: data, importo: singolaRata });
            });
            if (error) return;
            custom = custom.sort((a, b) => {
                return moment(a.data, 'DD/MM/yyyy').isBefore(b.data, 'DD/MM/yyyy') ? -1 : 1
            });

            let fattura = {
                ragione_sociale: this.state.ragioneSociale,
                tipo: this.state.tipoDocumento.label,
                numero: this.state.numeroFattura,
                data: data,
                sdi: this.state.sdi,
                importo: this.state.importo,
                tag: this.state.tag.label,
                scarico: this.state.tag.value,
                pagamento: this.state.metodoPagamento ? this.state.metodoPagamento.label : '',
                ritenuta: this.state.ritenuta,
                elettronica: this.state.elettronica,
                custom: custom,
                disposizioni: this.state.disposizioni
            };

            let res = await addFattura(username, token, fattura);
            if (res.result === 'ok') {
                deleteFatturaProvvisoria(username, token, this.state.fattura_provvisoria);
                for (const c of custom) {
                    if (moment(c.data, 'DD/MM/yyyy').isSameOrBefore(moment())) {
                        await addUscita(username, token, { id: res.id, tipo: 'fattura', importo: c.importo, data: c.data });
                    }
                }

                window.location.href = '/#/app/fatture';
                return;
            }

            this.setState({ isLoading: false });
            if (!res.error) {
                alert('Si è verificato un errore durante la creazione della fattura. Per favore, riprova.');
                return;
            }

            alert('Questo numero di fattura risulta già inserito per la ragione sociale indicata. Per favore, riprova.');

        } else {

            // Pagamento non fatturato
            if (!this.state.descrizione) {
                alert('Inserire una descrizione valida');
                return;
            }

            if (!this.state.importo) {
                alert('Inserire un importo per il pagamento');
                return;
            }

            var data = this.fatturaDateRef.current.getDate();
            data = moment(data).format('DD/MM/yyyy');
            if (moment(data, 'DD/MM/yyyy').isAfter(moment())) {
                this.setState({ isLoading: false });
                alert('Impossibile inserire una spesa non fatturata con una data successiva a quella odierna');
                return;
            }

            let uscita = {
                descrizione: this.state.descrizione,
                data: data,
                importo: this.state.importo,
                tag: this.state.tag.label,
                pagamento: this.state.metodoPagamento ? this.state.metodoPagamento.label : '',
            };

            let res = await addSpesa(username, token, uscita);
            if (res.result === 'ok') {
                window.location.href = '/#/app/fatture';
                return;
            }

            this.setState({ isLoading: false });
            alert('Si è verificato un errore inatteso. Per favore, riprova.');
        }

    }

}

